import { render, staticRenderFns } from "./BillingDateSection.vue?vue&type=template&id=8472fe30&"
import script from "./BillingDateSection.vue?vue&type=script&lang=js&"
export * from "./BillingDateSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports